import DeleteMediasAlbumModalComponent from "./DeleteMediasAlbumModalComponent";

export default DeleteMediasAlbumModalComponent;